import { createContext } from "react";
import type { RegisteredPageTour } from "./types";

export interface PageTourControls {
  open: boolean;
  pending: boolean;
  start: () => void;
  close: () => void;
}

export interface PageTourContextValue extends PageTourControls {
  register: (tour: RegisteredPageTour, pathname: string) => () => void;
  pathname: string;
  paused: boolean;
  tourId?: string;
  available: boolean;
}

export const PageTourContext = createContext<PageTourContextValue | null>(null);
